"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";
import { capturePostHogEvent } from "~/lib/posthog/client";

export function HomepageFaq({
  questions,
}: {
  questions: { question: string; answer: string; topic: string }[];
}) {
  return (
    <Accordion
      type="single"
      collapsible
      className="mt-10"
      onValueChange={(value) => {
        if (!value) return;

        capturePostHogEvent("homepage_trust_content_opened", {
          topic: questions[Number(value.replace("question-", ""))]?.topic,
        });
      }}
    >
      {questions.map((item, index) => (
        <AccordionItem
          key={item.question}
          value={`question-${index}`}
          className="border-border border-border/70"
        >
          <AccordionTrigger className="py-6 text-base font-bold text-foreground hover:text-brand hover:no-underline">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
